import { RouteConfig } from 'vue-router'
const Index = () => import('../views/sports-analyze/Index.vue')
const Detail = () => import('../views/sports-analyze/StandardMotionDetail.vue')
const Record = () => import('../views/sports-analyze/AnalyzeRecords.vue')
const StaticUploadIndex = () => import('../views/sports-analyze/static-upload-movement/Index.vue')

export const sportsAnaIndexRoute: RouteConfig = {
  path: '/sports-analyze-index',
  name: 'sports_analyze_index',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '选择动作',
  },
}

export const sportsAnaDetailRoute: RouteConfig = {
  path: '/standard-motion-detail',
  name: 'standard_motion_detail',
  component: Detail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '动作详情',
  },
}

export const sportsAnaRecordsRoute: RouteConfig = {
  path: '/sports-analyze-records',
  name: 'sports_analyze_records',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分析记录',
  },
}

export const sportsAnaStaticUploadIndex: RouteConfig = {
  path: '/sports-analyze-static-upload',
  name: 'sports_analyze_static_upload',
  component: StaticUploadIndex,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '添加新动作',
  },
}
export default [sportsAnaIndexRoute, sportsAnaDetailRoute, sportsAnaRecordsRoute, sportsAnaStaticUploadIndex]
